/* tslint:disable */
/* eslint-disable */
/**
 * AddOnSelector.Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FinishSelectionModel
 */
export interface FinishSelectionModel {
    /**
     * 
     * @type {string}
     * @memberof FinishSelectionModel
     */
    emailBody: string;
}

/**
 * Check if a given object implements the FinishSelectionModel interface.
 */
export function instanceOfFinishSelectionModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "emailBody" in value;

    return isInstance;
}

export function FinishSelectionModelFromJSON(json: any): FinishSelectionModel {
    return FinishSelectionModelFromJSONTyped(json, false);
}

export function FinishSelectionModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinishSelectionModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'emailBody': json['emailBody'],
    };
}

export function FinishSelectionModelToJSON(value?: FinishSelectionModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'emailBody': value.emailBody,
    };
}

